import React from 'react';
type PriceTagProps = {
  label?: string;
  className?: string;
  tone?: 'light' | 'dark';
};
export function PriceTag({
  label = 'Only',
  className = '',
  tone = 'light'
}: PriceTagProps) {
  const dark = tone === 'dark';
  return <div className={`inline-flex flex-col items-center rounded-lg border px-8 py-4 ${dark ? 'border-accent/60 bg-inverse-foreground/5' : 'border-accent/50 bg-surface shadow-card'} ${className}`} data-id="element-239" data-mp="1jmgsreh6br3q">
      <span className={`text-xs font-bold uppercase tracking-[0.24em] ${dark ? 'text-accent' : 'text-muted-foreground'}`} data-id="element-240" data-mp="19vujs33ypyu0">
        {label}
      </span>
      <span className={`mt-1 font-display text-5xl font-semibold leading-none sm:text-6xl ${dark ? 'text-accent-soft' : 'text-primary-strong'}`} data-id="element-241" data-mp="10xilrg0rnyrj">
        $27
      </span>
      <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-[0.2em] ${dark ? 'text-inverse-foreground/70' : 'text-muted-foreground'}`} data-id="element-242" data-mp="qxrstirutrtk">
        USD
      </span>
    </div>;
}